module.exports = __webpack_public_path__ + "img/saved-filled-blue.d07a0e70.svg";